module.exports = __webpack_public_path__ + "static/media/logo_staging.32fa7bcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/img/logo_staging.svg
// module id = 1827
// module chunks = 4